/**
 * Must be the first import of the app entry.
 *
 * vite-plugin-node-polyfills shadows `process` with its shim (env = {}) in every
 * module that references it. In dev, define() values only exist as globals injected
 * by /@vite/env, so the shim would hide them and PROCESS_ENV would be all-undefined.
 * `__APP_ENV__` is defined in vite.config.ts (global in dev, inlined in build);
 * merging it into the shim's env makes `process.env.*` reads work everywhere.
 */
declare const __APP_ENV__: Record<string, string | undefined>

Object.assign(process.env, __APP_ENV__)

export {}
